import { AttendeeStatus, StateFactory, getPresence, } from '@fluidframework/presence/beta';
function toPublic(wire) {
    return {
        userId: wire.userId ?? undefined,
        sessionCharacterId: wire.sessionCharacterId ?? undefined,
        currentApp: wire.currentApp ?? undefined,
    };
}
export function createPresenceManager(container) {
    const presence = getPresence(container);
    const workspace = presence.states.getWorkspace('datapad:presence', {
        userState: StateFactory.latest({
            local: { userId: null, sessionCharacterId: null, currentApp: null },
        }),
    });
    const state = workspace.states.userState;
    return {
        getConnectedUsers() {
            const users = [];
            for (const remote of state.getRemotes()) {
                if (remote.attendee.getConnectionStatus() === AttendeeStatus.Connected) {
                    users.push({
                        value: toPublic(remote.value),
                        attendee: remote.attendee,
                    });
                }
            }
            return users;
        },
        getMyself() {
            return {
                value: toPublic(state.local),
                attendee: presence.attendees.getMyself(),
            };
        },
        updateMyInfo(info) {
            state.local = {
                userId: info.userId ?? null,
                sessionCharacterId: info.sessionCharacterId ?? null,
                currentApp: info.currentApp ?? null,
            };
        },
        events: state.events,
        attendees: presence.attendees,
    };
}
//# sourceMappingURL=PresenceManager.js.map